import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useUndoNotificationRewrite = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (conversationId)=>api.notificationRewrite.undoRewrite(conversationId),
        withPageLoader: false
    });
    return {
        undoNotificationRewrite: mutateAsync,
        isLoading: isPending
    };
};
